module.exports = __webpack_public_path__ + "static/img/7areaB_06.2d2a6a8.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/7areaB_06.png
// module id = 1218
// module chunks = 1